import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'qaroni-payments-card-info',
  templateUrl: './payments-card-info.component.html',
  styleUrls: ['./payments-card-info.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class PaymentsCardInfoComponent {}
